
/************************** Cart Action ***************************/

import { Action } from "@ngrx/store";
import * as types from './constants/constants';
import { CategoryInterface, Social_interface, StaticPagesInterface } from "../../entites/footer-themes.model";


export class GET_FOOTER_CATEGORIES_ACTION implements Action
{

   readonly type: string = types.GET_FOOTER_CATEGORIES;
   constructor(){}

}


export class FOOTER_CATEGORIES_LOADED_ACTION implements Action
{

   readonly type: string = types.FOOTER_CATEGORIES_LOADED;
   constructor( public data: CategoryInterface[] ){}

}


export class GET_STATIC_PAGES_ACTION implements Action
{

   readonly type: string = types.GET_STATIC_PAGES;
   constructor(){}

}


export class STATIC_PAGES_LOADED_ACTION implements Action
{

   readonly type: string = types.STATIC_PAGES_LOADED;
   constructor( public data: StaticPagesInterface[] ){}

}



export class GET_SOCIALS_ACTION implements Action
{

   readonly type: string = types.GET_SOCIALS;
   constructor(){}

}


export class SOCIALS_LOADED_ACTION implements Action
{

   readonly type: string = types.SOCIALS_LOADED;
   constructor( public data: Social_interface[] ){}

}


export class GET_SITE_THEME_ACTION implements Action
{

   readonly type: string = types.GET_SITE_THEME;
   constructor(){}

}


export class SITE_THEME_LOADED_ACTION implements Action
{

   readonly type: string = types.SITE_THEME_LOADED;
   constructor( public data: any[] ){}

}




export type ActionsUnion = GET_FOOTER_CATEGORIES_ACTION & FOOTER_CATEGORIES_LOADED_ACTION;
